<script>

    export let active;
</script>

<nav class="navbar fixed-top navbar-expand-lg navbar-light bg-light">

    <a class="navbar-brand" href="#">
        <img src="../images/gcl_tran.png" alt="League Logo">
        <span class="d-none d-xl-block">MARCLIFF Gloucestershire County League</span>
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup"
        aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
        <ul class="navbar-nav">
            <li class="nav-item">
                <a class="nav-link" class:active={active==="home"} href="../default.html">Home<span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item dropdown">
                <!--About Dropdown-->
                <a class="nav-link dropdown-toggle" class:active={active==="about"} href="#" id="aboutDropdown" role="button"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    About
                </a>
                <div class="dropdown-menu" aria-labelledby="aboutDropdown">
                    <a class="dropdown-item" class:active={active==="honours"} href="../about/honours.html">Honours</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" class:active={active==="officers"} href="../about/officers.html">Officers</a>
                </div>
            </li>
            <!--End about Dropdown-->
            <li class="nav-item dropdown">
                <!--Reports Dropdown-->
                <a class="nav-link dropdown-toggle" class:active={active==="reports"} href="#" id="reportsDropdown" role="button"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    News/Reports
                </a>
                <div class="dropdown-menu" aria-labelledby="reportsDropdown">
                    <a class="dropdown-item" class:active={active==="latest"} href="../reports/reports.html">Latest Reports</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" class:active={active==="stats"} href="../stats/stats.html">Statistics</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" class:active={active==="archive"} href="../reports/reparch.html">Archive</a>
                </div>
            </li>
            <!--End Reports Dropdown-->
            <li class="nav-item">
                <a href="../respect/respect.html" class="nav-item nav-link" class:active={active==="respect"}>Respect</a>
            </li>
            <li class="nav-item">
                <a href="../clubs/clubs.html" class="nav-item nav-link" class:active={active==="clubs"}>Clubs</a>
            </li>
            <li class="nav-item">
                <a href="../cup/cup.html" class="nav-item nav-link" class:active={active==="cup"}>League Cup</a>
            </li>
            <li class="nav-item">
                <a href="../downloads/downloads.html" class="nav-item nav-link" class:active={active==="downloads"}>Downloads</a>
            </li>
            <a class="navbar-brand right float-right" href="http://www.marcliff.co.uk"
                target="_blank">
                <img src="../images/sponmar.png" alt="sponsor Logo">
            </a>
        </ul>
    </div>
</nav>

<style>

</style>